/**
 * api/designNavegacao.js — mapa de navegação do produto (Onda 2 do padrão de front).
 *
 * GET    /projects/{id}/design-studio/navigation                 → telas, transições, análise, casca
 * PUT    /projects/{id}/design-studio/navigation/decisions       → decide UMA transição
 * PUT    /projects/{id}/design-studio/navigation/decisions/batch → confirma várias
 * DELETE /projects/{id}/design-studio/navigation/decisions       → desfaz
 * PUT    /projects/{id}/design-studio/navigation/shell           → confirma a barra de uma plataforma
 * DELETE /projects/{id}/design-studio/navigation/shell/{plat}    → volta à proposta
 * POST   /projects/{id}/design-studio/navigation/propose         → sugestões da IA (não grava)
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client';

const key = (projectId) => ['design-navegacao', projectId];
const base = (projectId) => `/projects/${projectId}/design-studio/navigation`;

export function useNavegacao(projectId) {
  const api = useApi();
  return useQuery({
    queryKey: key(projectId),
    queryFn: () => api.get(base(projectId)),
    enabled: Boolean(projectId),
  });
}

/** Mutação que devolve o mapa atualizado e o põe no cache. */
function useMutacaoDoMapa(projectId, chamar) {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (corpo) => chamar(api, corpo),
    onSuccess: (data) => qc.setQueryData(key(projectId), data),
  });
}

export function useDecidirTransicao(projectId) {
  return useMutacaoDoMapa(projectId, (api, corpo) => api.put(`${base(projectId)}/decisions`, corpo));
}

export function useDecidirEmLote(projectId) {
  return useMutacaoDoMapa(projectId, (api, decisoes) =>
    api.put(`${base(projectId)}/decisions/batch`, { decisoes }));
}

export function useConfirmarCasca(projectId) {
  return useMutacaoDoMapa(projectId, (api, corpo) => api.put(`${base(projectId)}/shell`, corpo));
}

/** Sugestões da IA para o que a regra não decidiu. NÃO grava: quem confirma é o humano. */
export function useProporDestinos(projectId) {
  const api = useApi();
  return useMutation({
    mutationKey: ['ai'],
    meta: { aiLabel: 'Sugerindo o destino das ações pendentes…',
            aiSublabel: 'A sugestão só vale depois que você confirmar.' },
    mutationFn: () => api.post(`${base(projectId)}/propose`, {}),
  });
}
